const id_trans_stockopname = {
    "": "stock opname",
    add: "tambah stock opname",
    edit: "ubah stock opname",
    detail: "detail stock opname",
    trans_id: "ID Stock Opname",

    label: {
        btn_download_list: "unduh item list",
        btn_fnsh: "selesai stock opname",
        btn_approve_adj: "setuju dan sesuaikan",
        btn_submit_adj: "submit penyesuaian",
    },

    message: {
        conf_finish_title: "Apakah Anda yakin?",
        conf_finish_text: "Setelah data disimpan, Anda tidak akan dapat melakukan perubahan lagi!",
    },

    error: {
        delete: "Gagal menghapus data stock opname",
        failed_download: "Gagal mengunduh file",
        not_found: "Data stock opname tidak ditemukan",
        submit: "Gagal menyimpan data stock opname",
    },

    success: {
        delete: "Berhasil menghapus data stock opname",
        submit: "Berhasil menyimpan data stock opname",
    },
}

export default id_trans_stockopname;